// Central registry for data-testids used across the ImpactVest landing.
export const TESTIDS = {
  header: {
    root: "site-header",
    wordmark: "header-wordmark",
    navOverview: "nav-overview",
    navEvidence: "nav-evidence",
    navPassport: "nav-passport",
    navSecurity: "nav-security",
    navPlatform: "nav-platform",   // legacy id retained for backwards-compat tests
    navWhy: "nav-why",
    navHow: "nav-how",
    navPilot: "nav-pilot",
    ctaSignIn: "header-cta-signin",
    ctaRequest: "header-cta-request",
    ctaLive: "header-cta-live",
    mobileToggle: "header-mobile-toggle",
    mobilePanel: "header-mobile-panel",
    mobileClose: "header-mobile-close",
  },
  hero: {
    root: "hero",
    headline: "hero-headline",
    primaryCta: "hero-cta-primary",
    secondaryCta: "hero-cta-secondary",
    mockup: "hero-decision-record-mockup",
  },
  pathway: {
    heroChoice: "hero-pathway-choice",
    heroInvestorCta: "hero-pathway-investor-cta",
    heroCompanyCta: "hero-pathway-company-cta",
    split: "pathway-split",
    investorCard: "path-choice-investor",
    companyCard: "path-choice-company",
    navInvestor: "nav-investors",
    navCompany: "nav-companies",
    investorPage: "page-investors",
    companyPage: "page-companies",
    investorPrimaryCta: "investors-primary-cta",
    investorSecondaryCta: "investors-secondary-cta",
    companyPrimaryCta: "companies-primary-cta",
    companySecondaryCta: "companies-secondary-cta",
  },
  sections: {
    problem: "section-problem",
    platform: "section-platform",
    mandate: "section-mandate",
    record: "section-record",
    committee: "section-committee",
    brief: "section-brief",
    differentiation: "section-differentiation",
    knowledge: "section-knowledge",
    security: "section-security",
    pilotBand: "section-pilot",
  },
  footer: {
    root: "site-footer",
    linkPlatform: "footer-link-platform",
    linkPilot: "footer-link-pilot",
    linkSignIn: "footer-link-signin",
  },
  pilot: {
    form: "pilot-form",
    submit: "pilot-form-submit",
    success: "pilot-form-success",
    fields: {
      fullName: "pilot-field-full-name",
      email: "pilot-field-email",
      organization: "pilot-field-organization",
      role: "pilot-field-role",
      orgType: "pilot-field-org-type",
      geography: "pilot-field-geography",
      aum: "pilot-field-aum",
      investmentType: "pilot-field-investment-type",
      directCo: "pilot-field-direct-co",
      diligence: "pilot-field-diligence",
      challenge: "pilot-field-challenge",
      test: "pilot-field-test",
      users: "pilot-field-users",
      consent: "pilot-field-consent",
    },
  },
  login: {
    form: "login-form",
    email: "login-email",
    password: "login-password",
    submit: "login-submit",
    notice: "login-invite-notice",
  },
  admin: {
    tokenForm: "admin-token-form",
    tokenInput: "admin-token-input",
    tokenSubmit: "admin-token-submit",
    queue: "admin-queue",
    row: "admin-queue-row",
    statusSelect: "admin-status-select",
  },
};

export default TESTIDS;
